var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconwithBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5C1.5 5.08172 5.08172 1.5 9.5 1.5C13.9183 1.5 17.5 5.08172 17.5 9.5C17.5 13.9183 13.9183 17.5 9.5 17.5C5.08172 17.5 1.5 13.9183 1.5 9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5C1.5 5.08172 5.08172 1.5 9.5 1.5C13.9183 1.5 17.5 5.08172 17.5 9.5C17.5 13.9183 13.9183 17.5 9.5 17.5C5.08172 17.5 1.5 13.9183 1.5 9.5Z",
    stroke: "#EAECF0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_58496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31816 12.2999C5.33922 12.1104 5.34975 12.0156 5.37842 11.927C5.40386 11.8485 5.4398 11.7737 5.48527 11.7047C5.53652 11.627 5.60394 11.5596 5.73877 11.4248L11.7917 5.37188C12.2979 4.86562 13.1187 4.86562 13.625 5.37188C14.1313 5.87814 14.1313 6.69896 13.625 7.20522L7.5721 13.2581C7.43727 13.3929 7.36985 13.4603 7.29214 13.5116C7.22318 13.5571 7.1484 13.593 7.06983 13.6184C6.98126 13.6471 6.8865 13.6576 6.69698 13.6787L5.14581 13.8511L5.31816 12.2999Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_58496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconwithBorder);
export default __webpack_public_path__ + "static/media/EditIconwithBorder.2ef7ccc53da5e4a6edb12779b6cea82f.svg";
export { ForwardRef as ReactComponent };